export default "__VITE_ASSET__Bp8X3tc$__"